exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".covr-button button.loading .name{z-index:-1;opacity:0}.covr-button button.loading div{position:absolute}.covr-button .MuiButton-label{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Helpers/Buttons/Button.scss
// module id = 7086
// module chunks = 13